<template>
<CRow>
  <CCol>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-grid"/> {{caption}}
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="small ? 10 : 5"
        :dark="dark"
        :clickableRows=true
        :sorter='{ external: false, resetable: true }'
        :sorterValue="{ column: 'time', asc: false }"
        pagination       
      >

        <template #status="{item}">
          <td>
            <CBadge :color="getBadge(item.status)">{{item.status}}</CBadge>
          </td>
        </template>
       <template #msgGPSLink="{item}">
          <td> 
            <a v-bind:href="item.msgGPSLink" target="_blank"><CIcon name="cil-location-pin" /></a>
          </td>
        </template>        
      </CDataTable>
    </CCardBody>
  </CCard>
</CCol>

 <CCol sm="8" md="8">
  <CCard>
    <CCardHeader>
      <CIcon name="cil-justify-center"/>
      <strong>Envoi d'un message</strong>
    </CCardHeader>
    <CCardBody>
      <CRow>
          <CCol sm="2" md="2">
            <CDropdown               
              :toggler-text="getSelection()"
              class="m-2"
              color="secondary">
              <CDropdownItem v-if="$store.state.filterDevices.length>0"><button v-on:click="handleClick($store.state.filterDevices[0])">{{$store.state.filterDevices[0]}}</button></CDropdownItem>
              <CDropdownItem v-if="$store.state.filterDevices.length>1"><button v-on:click="handleClick($store.state.filterDevices[1])">{{$store.state.filterDevices[1]}}</button></CDropdownItem>
              <CDropdownItem v-if="$store.state.filterDevices.length>2"><button v-on:click="handleClick($store.state.filterDevices[2])">{{$store.state.filterDevices[2]}}</button></CDropdownItem>
              <CDropdownItem v-if="$store.state.filterDevices.length>3"><button v-on:click="handleClick($store.state.filterDevices[3])">{{$store.state.filterDevices[3]}}</button></CDropdownItem>
              <CDropdownItem v-if="$store.state.filterDevices.length>4"><button v-on:click="handleClick($store.state.filterDevices[4])">{{$store.state.filterDevices[4]}}</button></CDropdownItem>
              <CDropdownItem v-if="$store.state.filterDevices.length>5"><button v-on:click="handleClick($store.state.filterDevices[5])">{{$store.state.filterDevices[5]}}</button></CDropdownItem>
              <CDropdownItem v-if="$store.state.filterDevices.length>6"><button v-on:click="handleClick($store.state.filterDevices[6])">{{$store.state.filterDevices[6]}}</button></CDropdownItem>
              <CDropdownItem v-if="$store.state.filterDevices.length>7"><button v-on:click="handleClick($store.state.filterDevices[7])">{{$store.state.filterDevices[7]}}</button></CDropdownItem>
              <CDropdownItem v-if="$store.state.filterDevices.length>8"><button v-on:click="handleClick($store.state.filterDevices[8])">{{$store.state.filterDevices[8]}}</button></CDropdownItem>
              <CDropdownItem v-if="$store.state.filterDevices.length>9"><button v-on:click="handleClick($store.state.filterDevices[9])">{{$store.state.filterDevices[9]}}</button></CDropdownItem>
              <CDropdownItem v-if="$store.state.filterDevices.length>10"><button v-on:click="handleClick($store.state.filterDevices[10])">{{$store.state.filterDevices[10]}}</button></CDropdownItem>
              <CDropdownItem v-if="$store.state.filterDevices.length>11"><button v-on:click="handleClick($store.state.filterDevices[11])">{{$store.state.filterDevices[11]}}</button></CDropdownItem>
              <CDropdownItem v-if="$store.state.filterDevices.length>12"><button v-on:click="handleClick($store.state.filterDevices[12])">{{$store.state.filterDevices[12]}}</button></CDropdownItem>
              <CDropdownItem v-if="$store.state.filterDevices.length>13"><button v-on:click="handleClick($store.state.filterDevices[13])">{{$store.state.filterDevices[13]}}</button></CDropdownItem>
              <CDropdownItem v-if="$store.state.filterDevices.length>14"><button v-on:click="handleClick($store.state.filterDevices[14])">{{$store.state.filterDevices[14]}}</button></CDropdownItem>
            </CDropdown>
          </CCol>
          <CCol sm="5" md="5">
            <CInput
              v-model="message"
              description="Notez que le message depends du type d'unité."
              label="Msg texte a envoyer"
              horizontal
            />
          </CCol>
          <CCol sm="2" md="2">
                <CButton block color="warning" v-on:click="handleButton($event)">ENVOYER</CButton>
          </CCol>
      </CRow>    
      <CRow>    
        <CCol sm="3" md="3"/>
        <CCol sm="6" md="6">        
        {{Responses}}
        </CCol>
      </CRow>                      
    </CCardBody>
  </CCard>
</CCol>
</CRow>
</template>

<script>

//require('dotenv').config()
const APIURL = process.env.VUE_APP_API_URL

import axios from 'axios'


function numHex(s)
{
    var a = s.toString(16);
    if ((a.length % 2) > 0) {
        a = "0" + a;
    }
    return a;
}

function strHex(s)
{
    var a = "";
    for (var i=0; i<s.length; i++) {
        a = a + numHex(s.charCodeAt(i));
    }

    return a;
}


export default {

  name: 'CTableWrapperEmit',
  props: {  
    items: Array,
    fields: {
      type: Array,
      default () {
        return [ 
        { key: 'time',             label: 'dateAndTime', _style: 'width:160px;' },
        { key: 'serial',           label: 'serial', _style: 'width:30px;' },
        { key: 'status',           label: 'status', _style: 'width:30px;' },
        { key: 'provider',         label: 'provider', _style: 'width:30px;' },
        { key: 'providerAns',      label: 'providerAns', _style: 'min-width:20px; max-width:50px;' },
        { key: 'payload',          label: 'Payload', _style: 'min-width:40px; max-width:80px;' }, 
        { key: 'payloadLen',       label: 'payloadLen', _style: 'width:30px;' },
        { key: 'imei',             label: 'imei', _style: 'width:30px;' },
        { key: 'msgType',          label: 'msgType', _style: 'width:30px;' },
        ]
      }
    },
    caption: {
      type: String,  
      default: 'SNEmit'
    },
    clickableRows: Boolean ,
    hover: Boolean,
    striped: Boolean, 
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() 
  {
    return {
      message: "",
      ddSelection: " Choisir le # de Serie",
      ddSelectionIMEI: "",
      Responses: ""
    }

  },  
  methods: {
    getSelection()
    {
      return (this.ddSelection)
    },
     handleButton( e )
    {
        console.log('handleButton='+"@"+this.ddSelection+" send "+this.message)      

        for (var x=0; x< this.$store.state.filterDevices.length;x++)
        {
          //    console.log( this.$store.state.filterDevices[x] + ' - ' + this.$store.state.filterDevicesIMEI[x] )
            if (this.$store.state.filterDevices[x] == this.ddSelection)
            {
                this.ddSelectionIMEI = this.$store.state.filterDevicesIMEI[x]
                console.log( this.$store.state.filterDevices[x] + ' - ' + this.$store.state.filterDevicesIMEI[x] + "FOUND!")
                break;
            }
        }

        const res2 =  axios.post(
            APIURL+'/api1/messages',              
              { 
                imei:  this.ddSelectionIMEI,
                provider: "rockblock",
                status:0,
                msgSequence: 0,
                approxLat: 0.0,
                approxLong: 0.0,
                msgType:0,              
                direction: "MT",
                payload: this.message,
                payloadLen: this.message.length,
                creditUsed: 0
              },
              {   
                mode: 'no-cors',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                  },
              withCredentials: false
              }
          )
          .then(res => 
          {
            // console.log(res)
            this.Responses=res.data.providerAns

            var location = this.$route.fullPath
            console.log('go back to '+location)
            this.$router.replace('/')
            this.$nextTick(() => this.$router.replace(location))

          } )
          .catch(error =>  {
            console.error(error)
            this.Responses=  "ERROR: " + error
          });
          console.log(res2)
    },   
    handleClick( e )
    {
      this.ddSelection = e 
      this.ddSelectionIMEI = e
 
    },    
    getBadge (status) {
      return (status === 'Active') || (status === 'OK') ? 'success'
        : status === 'Inactive' ? 'secondary'
          : status === 'Pending' ? 'warning'
            : status === 'Banned' ? 'danger' : 'primary'
    },
    onTableChange () {
      this.loading = true
   //   console.log('onTableChange')
      setTimeout(() => {
          this.loading = false
          const agent = this.$refs.externalAgent
          this.loadedItems = agent.currentItems
          this.clickableRows = true
          this.pages = Math.ceil(agent.sortedItems.length / 5)
      }, 1000)
    }
  }  
} 
</script>
